import { LLAVE_CIFRADO, VECTOR_INICIO } from "../../api/config";
import {save} from "../../api/others";

//Función que obtiene los datos
export function sendGluster(file) {
    const formData = new FormData();
    formData.append("documento", file);
    return save(formData);
}

export function base64ToBlob( base64, type = "application/octet-stream" ) {
  const binStr = atob( base64 );
  const len = binStr.length;
  const arr = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    arr[ i ] = binStr.charCodeAt( i );
  }
  return new Blob( [ arr ], { type: type } );
}

export async function cifraTextoAESCBC256(texto) {
  try {
    const textEncode = new TextEncoder().encode(texto);
    let iv = str2ab(VECTOR_INICIO); //convertimos a array buffer
    let key = await importKey(); //creamos la llave de cifrado 
    let cipherText = await window.crypto.subtle.encrypt({name:"AES-CBC", iv}, key, textEncode); //ciframos
    //Convertimos a base64 el texto cifrado 
    var binary = '';
    var bytes = new Uint8Array( cipherText );
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
        binary += String.fromCharCode( bytes[ i ] );
    }
    return window.btoa(binary);
  } catch (exc) {
    console.error(exc);
  }
}

async function importKey() {
  var key = await crypto.subtle.importKey(
    "raw",
    str2ab(LLAVE_CIFRADO),
    { name: "AES-CBC" },
    true,
    ["decrypt", "encrypt"]
  );
  return key;
}

function str2ab(str) {
  const buf = new ArrayBuffer(str.length);
  const bufView = new Uint8Array(buf);
  for (let i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
}